export default {"wrapper":"poYjm","figure":"_9X6Xg","img":"u22wx","check":"q2Iha","texts":"r0UFq","title":"yGgiO","until":"Td9-K","lightTheme":"Lip8z"};